import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalendarComponent } from './calendar/calendar.component';
import { CalendardayComponent } from './calendarday/calendarday.component';
import { DatetimepickerComponent } from './datetimepicker/datetimepicker.component';
import { TimepickerComponent } from './timepicker/timepicker.component';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { OverlayModule } from '@angular/cdk/overlay';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
  declarations: [
    CalendarComponent,
    CalendardayComponent,
    DatetimepickerComponent,
    TimepickerComponent,
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatDialogModule,
    OverlayModule,
    FormsModule,
    MatButtonModule,
    MatSelectModule,
  ],
  exports: [
    CalendarComponent,
    CalendardayComponent,
    DatetimepickerComponent,
    TimepickerComponent,
  ],
})
export class DateandtimeselectionModule {}
